import React from 'react';
import styled, {keyframes, css} from 'styled-components';

const blink = keyframes`
    0%, 100% {
        opacity: 1;
        filter: brightness(2.5); /* 🌟 brighter */
    }
    50% {
        opacity: 0.8;
        filter: brightness(1.5); /* 🌑 dimmer */
    }
`;

const rotate = keyframes`
    from {
        transform: translate(-50%, -50%) rotate(0deg);
    }
    to {
        transform: translate(-50%, -50%) rotate(360deg);
    }
`;

const Wrapper = styled.div<{ size: number, reverse?: boolean }>`
    position: absolute;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 10;
    animation: ${rotate} 20s linear infinite;
    animation-direction: ${props => props.reverse ? 'reverse' : 'normal'}; /* 🔥 Key line */
`;


const Bulb = styled.div<{
    x: number;
    y: number;
    delay: string;
    color: string;
    bulbSize: number;
}>`
    position: absolute;
    width: ${props => props.bulbSize}px;
    height: ${props => props.bulbSize}px;
    left: ${props => props.x}px;
    top: ${props => props.y}px;
    border-radius: 50%;
    background-color: ${props => props.color};
    animation: ${blink} 2s infinite;
    animation-delay: ${props => props.delay};
    box-shadow: 0 0 10px 2px #a88b8b;

`;

interface BulbCircleProps {
    radius?: number;
    color: string;
    size?: number;
    bulbSize?: number;
    count?: number;
    reverse?: boolean;  // 👈 add this
}


const BulbCircle: React.FC<BulbCircleProps> = ({
                                                   radius = 29,
                                                   color,
                                                   size = 100,
                                                   bulbSize = 5,
                                                   count = 8,
                                                   reverse,
                                               }) => {
    const bulbs = Array.from({length: count}, (_, i) => {
        const angle = (360 / count) * i;
        const radians = (angle * Math.PI) / 180;
        const x = size / 2 + radius * Math.cos(radians) - bulbSize / 2;
        const y = size / 2 + radius * Math.sin(radians) - bulbSize / 2;
        const delay = i % 2 === 0 ? '0s' : '1s';
        return {x, y, delay};
    });

    return (
        <Wrapper size={size} reverse={reverse}>
            {bulbs.map((b, i) => (
                <Bulb
                    key={i}
                    x={b.x}
                    y={b.y}
                    delay={b.delay}
                    color={color}
                    bulbSize={bulbSize}
                />
            ))}
        </Wrapper>
    );

};

export default BulbCircle;
